import ServicePage from "@/components/ServicePage";

export default function NationwideVehicleTransport() {
  return (
    <ServicePage
      slug="nationwide-vehicle-transport"
      testid="page-nationwide-vehicle-transport"
      title="Nationwide Vehicle Transport UK | Any Postcode, Any Vehicle | MHJ Prestige Transport"
      metaDescription="Nationwide vehicle transport across the UK — Scotland to Cornwall. Instant online quote, door-to-door collection, fully insured. Book online with MHJ Prestige Transport."
      h1="Nationwide vehicle transport — any postcode, any vehicle"
      intro="We move cars, vans and light commercials to and from every UK mainland postcode. Book your route online in minutes with a firm, fully-inclusive price."
      heroImage="https://customer-assets.emergentagent.com/job_transport-hub-345/artifacts/3n3iv3ni_Screenshot_20260609_112234_Gallery.jpg"
      bullets={[
        "Full UK mainland coverage — Highlands, South Coast, Wales, Kent, Cornwall",
        "Same-day and next-day slots subject to availability",
        "Fixed price on booking — no hidden fuel or mileage surcharges",
        "Open, covered and enclosed transporters",
        "Multi-drop and multi-collection runs for traders",
        "Live route calculation via Google — no guesswork on miles",
      ]}
      sections={[
        {
          title: "Any postcode, any distance",
          body: (
            <p>
              Whether you&rsquo;re moving one car from Aberdeen to Truro or a run of trade stock between
              Midlands sites, our instant quote engine calculates true driving mileage in real time
              — so the price you see is the price you pay.
            </p>
          ),
        },
        {
          title: "Trade and dealership accounts",
          body: (
            <p>
              We run weekly movements for a growing list of dealerships and trade buyers. Get in
              touch if you&rsquo;d like a bulk-rate account and priority slots.
            </p>
          ),
        },
      ]}
      faq={[
        {
          q: "Do you cover Scotland and Wales?",
          a: "Yes — the full UK mainland including Highlands, Scottish Islands (via ferry), Anglesey and Cornwall.",
        },
        {
          q: "How fast can you collect nationwide?",
          a: "Same-day is possible subject to availability. Standard slots are typically 24-72 hours after booking.",
        },
        {
          q: "Do you go to Northern Ireland or Republic of Ireland?",
          a: "Yes on quote — some Ireland moves fall outside instant-quote and are priced manually. Contact us for a firm price.",
        },
        {
          q: "Are all your transporters covered?",
          a: "We operate both open and covered/enclosed transporters. Enclosed is a paid upgrade shown in your quote.",
        },
      ]}
    />
  );
}
